import { render, staticRenderFns } from "./FeatureSection.vue?vue&type=template&id=539fc701&scoped=true&"
import script from "./FeatureSection.vue?vue&type=script&lang=js&"
export * from "./FeatureSection.vue?vue&type=script&lang=js&"
import style0 from "./FeatureSection.vue?vue&type=style&index=0&id=539fc701&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539fc701",
  null
  
)

export default component.exports